import cookieConsentJson from "@/data/copy/cookie-consent.json";
import { createCopyGetter } from "@/lib/localize-copy";
import type { Lang } from "@/lib/types";

const getCookieConsentCopyTree = createCopyGetter(cookieConsentJson);

export type CookieConsentCopy = ReturnType<typeof getCookieConsentCopyTree>;

export function getCookieConsentCopy(lang: Lang): CookieConsentCopy {
  return getCookieConsentCopyTree(lang);
}
